import React, {useState, useEffect} from 'react';
import ReactApexChart from 'react-apexcharts';
import pl from "apexcharts/dist/locales/pl.json";

const VerticalBar = ({displayData, loading, name, title, value_type, start, end}) => {
    const [Series, setSeries] = useState([])
    const [Categories, setCategories] = useState([])
    const valueConvert = (val, prec = 2) => {
       if (typeof val === typeof 1) {
             if(value_type === " dni")
                prec = 0;

            return (Number(val).toFixed(prec)).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".", ",") + value_type

        }

        return val + value_type
    }
    const displayTitle = ()=>{
        if((new Date(start).getMonth() === new Date(end).getMonth()) && (new Date(start).getFullYear()=== new Date(end).getFullYear()))
            return " za " + (new Date(start).getMonth() + 1) + "/" + new Date(start).getFullYear();

        return (start ? (" od " + (new Date(start).getMonth() + 1) + "/" + new Date(start).getFullYear()) : "") + (end ? (" do " + (new Date(end).getMonth() + 1) + "/" + new Date(end).getFullYear()) : "")
    }
    useEffect(() => {
        if (displayData && Array.isArray(displayData) && displayData.length >0) {
            let Polska = {}
            let TwojSzpital = {}
            if (displayData[1]['nazwa_regionu'] === "Polska") {
                Polska = displayData[1];
                TwojSzpital = displayData[0];
            } else {
                Polska = displayData[0];
                TwojSzpital = displayData[1];
            }

            const series = [TwojSzpital['wartosc_wskaznika'], Polska['max'], Polska['wartosc_wskaznika'], Polska['min'],]
            const categories = [TwojSzpital['nazwa_regionu'], 'Max', 'Mediana', 'Min',]
            setSeries(series)
            setCategories(categories)
        }
    }, [displayData])
    const ColorPalette = ['rgb(255,211,35)', 'rgba(107, 188, 212,1)', 'rgba(107, 188, 212, 0.6)', 'rgba(107, 188, 212, 0.20)',]

    const series = [{
        data: Series
    }]
    const options = {
        chart: {
            type: 'bar',
            height: 350,
            locales: [pl],
            animations: {
                enabled: false,
            },
            defaultLocale: "pl",
            toolbar: {
                offsetX: -100,
                offsetY: 0,
                tools: {
                    download: true,
                    selection: false,
                    zoom: false,
                    zoomin: false,
                    zoomout: false,
                    pan: false,
                    reset: false,
                },
                export: {
                    csv: false,
                    png: {
                        filename: "Wykres",
                    }
                },
            },
        },
        grid: {
            yaxis: {
                lines: {
                    show: true
                }
            },
        },
        plotOptions: {
            bar: {
                borderRadius: 10,
                barHeight: '50%',
                distributed: true,
                horizontal: true,
                dataLabels: {
                    position: 'top'
                },
            }
        },
        colors: ColorPalette,
        dataLabels: {
            enabled: true,
            formatter: function (val) {
                return valueConvert(val)
            },
            style: {
                fontSize: '12px',
                colors: ["rgba(77,77,77,0.93)"]
            },
            offsetX: 35,

        },

        stroke: {
            width: 0,
            colors: ['#000']
        },
        xaxis: {
            categories: Categories,
            display: true,
            labels: {
                formatter: function (val) {
                    try {
                        return valueConvert(val,0)
                    } catch (e) {
                        return val
                    }
                }
            }


        },
        // yaxis: {
        //      labels: {
        //         formatter: function (val) {
        //             try {
        //                 return valueConvert(val)
        //             } catch (e) {
        //                 return val
        //             }
        //         }
        //     }
        //
        // },
        title: {
            text: name + displayTitle(),
            align: 'center',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
                fontSize: '14px',
                fontWeight: 600,
                fontFamily: "Montserrat, Helvetica Neue",
                color: '#263238'
            },
        },
        subtitle: {
            text: title,
            align: 'center',
            margin: 10,
            offsetX: 0,
            offsetY: 25,
            floating: false,
            style: {
                fontSize: '14px',
                fontWeight: 500,
                fontFamily: "Montserrat, Helvetica Neue",
                color: '#263238'
            },
        },
        legend: {
            show: false
        },
        tooltip: {
            followCursor: true,
            custom: function ({series, seriesIndex, dataPointIndex, w}) {
                let tooltip = '<div class="arrow-box" style="padding: 5px; font-size:12px ">'
                tooltip += '<div style="padding: 3px;"><strong>'
                tooltip += Categories[dataPointIndex] + ':</strong> ' + valueConvert(series[seriesIndex][dataPointIndex]) + '<br>'
                tooltip += '</div></div>'
                return tooltip
            }
        },
        noData: {
            text: "Błąd pobierania danych spróbuj ponownie.",
            align: 'center',
            verticalAlign: 'middle',
            offsetX: 0,
            offsetY: 0,
            style: {
                fontSize: '14px',
                fontWeight: 600,
                fontFamily: "Montserrat, Helvetica Neue",
                color: '#263238'
            },
        }
    }
    return (
        <div id="chart">
            <ReactApexChart options={options} series={series} type="bar" height={350}/>
            <div style={{fontSize: "12px",textAlign:"left"}}>
                * Na wykresie zaprezentowano

                wartość maksymalną, minimalną i medianę danego wskaźnika dla podmiotów o podobnej kategorii

                i formie prawnej w Polsce

            </div>
        </div>
    )
};

export default VerticalBar;